/// <reference lib="webworker" />

self.onmessage = function handleMessageFromMain({data}) {
  if(typeof data !== 'string'){return}
  if(!data.includes('/api/v')){return}
  fetch(data).then(function(response){
    return response.json().then(function(config){
      postMessage(config);
    })
  });
};
